// In-memory, session-scoped return state for the dashboard: which page the
// user was on, how far down it they were, and which theme they had open.
// Leaving for a stock chart and coming back lands exactly where they were —
// with no URL params (house rule: clean address bar). Module state resets
// naturally on a full reload or app relaunch, which is the right time to
// start fresh.

interface DashboardMemory {
  tab?: string;
  scrollY?: number;
  themeKey?: string;
}

const memory: DashboardMemory = {};

export const rememberDashboardPlace = (tab: string, scrollY: number): void => {
  memory.tab = tab;
  memory.scrollY = scrollY;
};

export const recallDashboardTab = (): string | undefined => memory.tab;

/** One-shot: the saved scroll applies to the next mount only. */
export const consumeDashboardScroll = (): number | undefined => {
  const scrollY = memory.scrollY;
  memory.scrollY = undefined;
  return scrollY;
};

export const rememberThemeKey = (key: string): void => {
  memory.themeKey = key;
};

export const recallThemeKey = (): string | undefined => memory.themeKey;
